import FloatingSupportChat from '../components/FloatingSupportChat/FloatingSupportChat'
import { bindActionCreators } from 'redux'
import {connect} from 'react-redux'
import {actions} from '../modules/chat'
import * as notificationActions from '../modules/notificationActionCreators'

const mapStateToProps = (state, ownProps) => {
  return {
    ...ownProps,
    showChatRoom: state.chat.showFloatingSupportChatRoom,
    unreadChatrooms: state.notification.unreadChatrooms,
  }
}

const mapDispatchToProps = dispatch => bindActionCreators({
  fetchChatrooms: actions.fetchChatrooms,
  toggleShowChatRoom: actions.toggleShowSupportChatRoom,
  fetchNotifications: notificationActions.fetchNotifications,
}, dispatch)

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(FloatingSupportChat)



// WEBPACK FOOTER //
// ./src/containers/FloatingSupportChatContainer.js